import { ExtendedTheme, MessageView } from 'neon-design-system';
import { createStyles, makeStyles } from '@material-ui/styles';

interface Props {
  noRequestsToDisplayTitle?: string;
  noRequestsToDisplayDescription?: string;
}

const useStyles = makeStyles((theme: ExtendedTheme) =>
  createStyles({
    wrapper: {
      background: theme.palette.background.paper,
      padding: theme.spacing(8, 8, 4)
    }
  })
);

export const NoRequestsToDisplayView = ({
  noRequestsToDisplayTitle = 'No requests to display',
  noRequestsToDisplayDescription = 'There are no requests to display. Try changing some filters to update this view.'
}: Props) => {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <MessageView styleName="primary" size="medium" title={noRequestsToDisplayTitle}>
        {noRequestsToDisplayDescription}
      </MessageView>
    </div>
  );
};
